import React from "react";
import { useNavigate } from "react-router";
import Empty from "../Empty";
import { dateToString } from "~/utils/formatter";
import { PaginationIcon, QuestionMarkIcon } from "~/assets/svg/InterfaceIcon";
import "~/assets/sass/pages/dashboard/dashboard-review.scss";
import { useTranslation } from "react-i18next";

const Apply = ({ applyList, checkAuth, authPlugins }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	return (
		<article className="item review">
			<div className="title-wrap">
				<div className="left-title-wrap">
					<h2 className="item-title">{t("pages.DashboardPage.Apply.item-title")}</h2>
					<div className="c__tooltip-btn">
						<QuestionMarkIcon />
						<p className="c__tooltip apply">
							<b>{t("pages.DashboardPage.Apply.tooltipMainTitle")}</b>
							{t("pages.DashboardPage.Apply.tooltip")}
							<p className="desc">
								<b>{t("pages.DashboardPage.Apply.tooltipSubTitle.01")}</b>
								{t("pages.DashboardPage.Apply.tooltipDesc.01")}
							</p>
							<p className="desc">
								<b>{t("pages.DashboardPage.Apply.tooltipSubTitle.02")}</b>
								{t("pages.DashboardPage.Apply.tooltipDesc.02")}
							</p>
						</p>
					</div>
				</div>
				<button
					type="button"
					className="btn-more"
					onClick={() => navigate("/apply/evaluate")}
				>
					<PaginationIcon />
				</button>
			</div>
			{applyList?.length > 0 ? (
				<div className="c__table">
					<div className="thead">
						<div className="tr">
							<div className="th name">
								{t("pages.DashboardPage.Apply.table.th1")}
							</div>
							<div className="th date">
								{t("pages.DashboardPage.Apply.table.th2")}
							</div>
							<div className="th status">
								{t("pages.DashboardPage.Apply.table.th3")}
							</div>
						</div>
					</div>
					<div className="tbody">
						{applyList?.map((apply, index) => (
							<div className="tr" key={index}>
								<div className="td name">{apply.company}</div>
								<div className="td date">
									{dateToString(apply.createdAt, "yyyy-MM-dd")}
								</div>
								{apply.investStatus === "심사완료" && (
									<div className="td status completed">
										{t("pages.DashboardPage.Apply.table.completed")}
									</div>
								)}
								{(apply.investStatus === "심사중" ||
									apply.investStatus === "심사대기") && (
									<div className="td status">
										<button
											className="btn__solid btn-review"
											color="primary"
											onClick={() =>
												navigate(`/apply/evaluate?modalIdx=${apply.idx}`)
											}
										>
											{t("pages.DashboardPage.Apply.table.review")}
										</button>
									</div>
								)}
							</div>
						))}
					</div>
				</div>
			) : checkAuth === "admin" ? (
				<Empty
					message={t("pages.DashboardPage.Apply.Empty-admin")}
					button={t("pages.DashboardPage.Apply.create")}
					handleAdd={() => navigate("/applyForm/view")}
				/>
			) : authPlugins?.includes("Apply 심사") ? (
				<Empty message={t("pages.DashboardPage.Apply.Empty-reviewer")} />
			) : (
				<div className="no-auth-wrap">
					<p className="no-auth-desc">{t("pages.DashboardPage.Apply.no-auth-desc")}</p>
				</div>
			)}
		</article>
	);
};

export default Apply;
